module.exports = __webpack_public_path__ + "static/media/communityIcon.0f272b8a.png";